import { STRING } from "../../Component/Modals/ModalComponents/ModalInputTypes";
import { RiBuilding4Fill } from "react-icons/ri";
import { SIMPLE } from "../../Component/Sidebar/PageTypes";
const Viloyat = {
  title: "Viloyatlar",
  path: "/servis/viloyat",
  icon: <RiBuilding4Fill></RiBuilding4Fill>,
  type: SIMPLE,
  columns: [
    {
      title: <div className="table_head">№</div>,
      key: "index",
      render: (text, record, index) => index + 1,
      width: "50px",
      align: "center",
    },
    {
      title: <div className="table_head">Viloyat nomi</div>,
      dataIndex: "nomi",
      key: "nomi",
    },
  ],
  forms: [
    {
      grid: "1fr",
      inputs: [
        {
          label: "Viloyat nomi",
          name: "nomi",
          type: STRING,
          required: true,
        },
      ],
    },
  ],
};

export default Viloyat;
